// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"564":"344eff77","572":"82d1f898","809":"bdd319b5"}[chunkId] + ".chunk.css";
};